import React, { useState } from 'react';
import Home from './Home';
import { signOut } from 'firebase/auth';
import Login from './Login';
import Posts from './Posts';
// import Hook from './Hooks';
// import Component from './Components';
import './Home.css';
import './Posts.css';
import './Login.css';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import { auth } from './firebaseConfig';

function App() {
  const signUserOut = () => {
    signOut(auth).then(() => {
      localStorage.clear();
      setIsAuth(false);
      window.location.pathname = '/Login';
    });
  };
  const [isAuth, setIsAuth] = useState(localStorage.getItem('isAuth'));
  return (
    <Router>
      <nav>
        <Link to="/">Home</Link>

        {!isAuth ? (
          <Link to="/Login">Login</Link>
        ) : (
          <>
            <Link to="/Posts">Post</Link>
            <button id="signOut" onClick={signUserOut}>
              Logout
            </button>
          </>
        )}
      </nav>
      {/* <Component/> */}

      <Routes>
        <Route path="/" element={<Home isAuth={isAuth} />} />
        <Route path="/Posts" element={<Posts isAuth={isAuth} />} />
        <Route path="/Login" element={<Login setIsAuth={setIsAuth} />} />
      </Routes>
    </Router>
  );
}

export default App;
